import { IResponse } from "models";

export enum ActionType {
  UPDATE_RELEASE_DATE = "action/UPDATE_RELEASE_DATE",
  UPDATE_RELEASE_DATE_SUCCESS = "action/UPDATE_RELEASE_DATE_SUCCESS",
  UPDATE_RELEASE_DATE_ERROR = "action/UPDATE_RELEASE_DATE_ERROR",
  UPDATE_RELEASE_DATE_RESET = "action/UPDATE_RELEASE_DATE_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IReleaseDateItem {
  id: number;
  day_left: number;
}

export interface IUpdateReleaseDatePayload {
  company_users: IReleaseDateItem[];
}

export interface UpdateReleaseDateResponse extends IResponse {}
